import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import { H2 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ModalWrapper = ({
  onClose,
  modalName,
  Body,
  Footer,
  illustrationName
}) => {
  const width = illustrationName ? 900 : 800;
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: width,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      "data-test-id": "modal-close-button",
      onClick: onClose
    }), /*#__PURE__*/_jsxs(UIFlex, {
      className: "p-all-10",
      children: [/*#__PURE__*/_jsxs(UIBox, {
        children: [/*#__PURE__*/_jsx(UIDialogHeader, {
          className: "text-left",
          children: /*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `embedPoints.${modalName}.title`
            })
          })
        }), /*#__PURE__*/_jsx(UIDialogBody, {
          className: "text-left",
          children: Body
        }), /*#__PURE__*/_jsx(UIDialogFooter, {
          children: Footer
        })]
      }), illustrationName && /*#__PURE__*/_jsx(UIBox, {
        alignSelf: "center",
        children: /*#__PURE__*/_jsx(UIIllustration, {
          name: illustrationName,
          width: "350px"
        })
      })]
    })]
  });
};
export default ModalWrapper;